// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-privacy-text[data-v-7a6a31ec]{display:flex;font-size:90%;margin-top:.5em}", ""]);
// Exports
module.exports = exports;
